import React, { useEffect, useRef, useState } from "react";
import "./UploadFileModal.css";
import { Button, Form, Modal } from "react-bootstrap";
import Successfull_Lottie from "../../../Animation/Successfull_Lottie/Successfull_Lottie";
import UploadFile_Lottie from "../../../Animation/UploadFile_Lottie/UploadFile_Lottie";
import Black_Btn from "../../Common_Btn/Black_Btn/Black_Btn";
import CheckOutProcessOffCanvas from "../CheckOutProcessOffCanvas/CheckOutProcessOffCanvas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Controller, useForm } from "react-hook-form";

function UploadFileModal({ product,combination, checkOutProcessBaseLink, ...props }) {
  const [showOffCanvas, setShowOffcanvas] = useState(false);

  //   const fileInputRef = useRef(null);
  //   const [fileName, setFileName] = useState("");

  //   const handleDivClick = () => {
  //     fileInputRef.current.click();
  //   };

  //   const handleFileChange = (event) => {
  //     const file = event.target.files[0];
  //     if (file) {
  //       setFileName(file.name);
  //     }
  //   };

  const fileInputRef = useRef(null);

  const {
     control,
     register,
     handleSubmit,
     getValues,
     setError,
     clearErrors,
     formState: { errors },
     reset,
     trigger,setValue,
   } = useForm();
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleDivClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files); // Convert FileList to Array
    if (files.length) {
      setSelectedFiles(files);
      setValue("files", files); // Set files in React Hook Form
    }
  };
  const [data, setData] = useState([]);
  const onSubmit = (data) => {
    
    data.product=product;
    data.combination=combination;
    setData(data);
    props?.onHide();
    setShowOffcanvas(true);
    
  };

  

  return (
    <>
      <section className="UploadFileModal modal-holder">
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="UploadFileModal modal-holder"
        >
          <Modal.Body>
            <div className="success_main_div">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="upload_file_input"
                  onClick={handleDivClick}
                  style={{ cursor: "pointer" }}
                >
                  <div className="success_loottie_holder">
                    <UploadFile_Lottie />
                  </div>
                  <p className="heading">Upload your files</p>

                  <Controller
                    name="files"
                    control={control}
                    rules={{
                        validate: (value) => (value && value.length > 0) || "At least one file is required",
                    }}
                    render={({ field }) => (
                      <input
                        type="file"
                        ref={(e) => {
                          fileInputRef.current = e;
                          field.ref(e);
                        }}
                        style={{ display: "none" }}
                        accept=".png,.tiff,.jpg,.psd,.ai,.pdf,.svg,.cdr,.docx,.pptx,.eps,.zip"
                        onChange={(event) => {
                          handleFileChange(event);
                          field.onChange(event.target.files);
                        }}
                        multiple
                      />
                    )}
                  />
                  {errors.files && <sup className="text-danger">{errors.files.message}</sup>}
                </div>

                <p className="instruction_text">
                  Supported file formats: PNG, TIFF, JPG, PSD, AI, PDF, SVG,
                  CDR, DOCX, PPTX, EPS, ZIP
                </p>

                {selectedFiles.length > 0 && (
                  <>
                    <div className="selected_file_div">
                      <div className="label_div">
                        <div className="left_side">
                          <p className="label">
                            Uploaded Files ({selectedFiles.length})
                          </p>
                        </div>
                        
                      </div>

                      <div className="filename_holder">
                        {selectedFiles.map((file, index) => (
                          <div key={index} className="file_item">
                            <p className="filename">{file.name}</p>
                            <div className="delete_icon_div"> <FontAwesomeIcon
                              icon={faTrash}
                              className="icon"
                              onClick={() => {
                                const newFiles = selectedFiles.filter(
                                  (_, i) => i !== index
                                );
                                setSelectedFiles(newFiles);
                                setValue("files", newFiles);
                              }}
                            /></div>
                           
                          </div>
                        ))}
                      </div>
                    </div>

                 
                  </>
                )}

                <div className="form_container">
                  <Form.Group className="form-group">
                    <Form.Label>Share design instruction here</Form.Label>
                    <Controller
                            name="design_instruction"
                            control={control}
                            rules={{ required: "Design Instructions are required" }}
                            render={({ field }) => (
                                <Form.Control as="textarea" placeholder="Additional Information" {...field} />
                            )}
                        />
                        {errors.design_instruction && <sup className="text-danger">{errors.design_instruction.message}</sup>}
              

                  </Form.Group>

                  <div
                    className="upload_btn_holder"
                    // onClick={() => {
                    //   props?.onHide();
                    //   setShowOffcanvas(true);
                    // }}
                  >
                    <Black_Btn btnText="Upload Files" type={'submit'}/>
                  </div>
                </div>
              </form>
            </div>
            {/* <div className="success_main_div">
              <div
                className="upload_file_input"
                onClick={handleDivClick}
                style={{ cursor: "pointer" }}
              >
                <div className="success_loottie_holder">
                  <UploadFile_Lottie />
                </div>

                <p className="heading">Upload your files</p>

                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  accept=".png,.tiff,.jpg,.psd,.ai,.pdf,.svg,.cdr,.docx,.pptx,.eps,.zip"
                  onChange={handleFileChange}
                />
              </div>

              <p className="instruction_text">
                Supported file formats : PNG, TIFF, JPG, PSD, AI, PDF, SVG, CDR,
                DOCX, PPTX, EPS, ZIP
              </p>

              {fileName && (
                <div className="selected_file_div">
                  <div className="label_div">
                    <div className="left_side">
                      <p className="label">Uploaded Files (1)</p>
                    </div>

                    <div className="delete_icon_div">
                      <FontAwesomeIcon icon={faTrash} className="icon" />
                    </div>
                  </div>

                  <div className="filename_holder">
                    <p className="filename"> {fileName}</p>
                  </div>
                </div>
              )}

              <div className="form_container">
                <Form>
                  <Form.Group className="form-group">
                    <Form.Label>Share design instruction here</Form.Label>
                    <Form.Control
                      type="text"
                      as={"textarea"}
                      name="name"
                      placeholder="Additional Information"
                    />
                  </Form.Group>

                  <div
                    className="upload_btn_holder"
                    onClick={() => {
                      props?.onHide();
                      setShowOffcanvas(true);
                    }}
                  >
                    <Black_Btn btnText="Upload Files" />
                  </div>
                </Form>
              </div>
            </div> */}
          </Modal.Body>
        </Modal>

        <CheckOutProcessOffCanvas
        data={data}
          onHide={() => setShowOffcanvas(false)}
          show={showOffCanvas}
          checkOutProcessBaseLink={checkOutProcessBaseLink}
        />
      </section>
    </>
  );
}

export default UploadFileModal;
